import {useState, createContext} from 'react'
import {getItemFromStorage, setDataInStorage} from 'utils/storage'

export const UserContext = createContext()

export const UserProvider = ({children}) => {
  const [currentUser, setCurrentUser] = useState(
    getItemFromStorage({name: 'user'})
  )

  const [wallet, setWallet] = useState({balance: 0, currency: 'USD'})

  const updateUser = (newUser) => {
    setCurrentUser(newUser)
    setDataInStorage({name: 'user', data: newUser})
  }

  const updateWallet = (newWallet) => {
    setWallet(newWallet)
  }

  return (
    <UserContext.Provider
      value={{currentUser, updateUser, wallet, updateWallet}}
    >
      {children}
    </UserContext.Provider>
  )
}
